import { z, ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';

export type ShiftReport = {
	id: string;
	cashier: EntityWithName;
	cashdesk: EntityWithName;
	account: EntityWithName;
	startTime: string;
	endTime: string | null;
	currency: string;
	openingBalance: number;
	closingBalance: number;
	deposits: number;
	withdrawals: number;
	jackpots: number;
	bonuses: number;
	vouchers: number;
	income: number;
	rtp: number;
	numberOfBets: number;
	incomeAllSources: number;
	rtpAllSources: number;
};

export const shiftReportSchema: ZodType<ShiftReport> = z.object({
	id: z.string(),
	cashier: entityWithNameSchema,
	cashdesk: entityWithNameSchema,
	account: entityWithNameSchema,
	startTime: z.string(),
	endTime: z.string().nullable(),
	currency: z.string(),
	openingBalance: z.number(),
	closingBalance: z.number(),
	deposits: z.number(),
	withdrawals: z.number(),
	jackpots: z.number(),
	bonuses: z.number(),
	vouchers: z.number(),
	income: z.number(),
	rtp: z.number(),
	numberOfBets: z.number(),
	incomeAllSources: z.number(),
	rtpAllSources: z.number(),
});

export type ShiftReportAdditionalData = {
	summary: {
		currency?: string;
		deposits?: number;
		withdrawals?: number;
		jackpots?: number;
		bonuses?: number;
		vouchers?: number;
		income?: number;
		incomeAllSources?: number;
		rtp: number;
		rtpAllSources: number;
		numberOfBets: number;
	};
};

export const shiftReportAdditionalDataSchema: ZodType<ShiftReportAdditionalData> = z.object({
	summary: z.object({
		currency: z.string().optional(),
		deposits: z.number().optional(),
		withdrawals: z.number().optional(),
		jackpots: z.number().optional(),
		bonuses: z.number().optional(),
		vouchers: z.number().optional(),
		income: z.number().optional(),
		incomeAllSources: z.number().optional(),
		rtp: z.number(),
		rtpAllSources: z.number(),
		numberOfBets: z.number(),
	}),
});
